<template>
  <div id="dashboard" class="content">
    <div class="block block-rounded block-bordered">
      <ul class="nav nav-tabs nav-tabs-block" data-toggle="tabs" role="tablist">
        <li class="nav-item" v-for="(item,index) in bis" :key="index">
          <a
            class="nav-link"
            :class="item.BIS_TYPE == type ? 'active' + ' btabs-animated-fade-'+item.BIS_TYPE : 'btabs-animated-fade-'+item.BIS_TYPE "
            href="javascript:void(0)"
            @click="showTab('btabs-animated-fade-'+item.BIS_TYPE,item.BIS_TYPE)"
          >{{item.BIS_NAME}}</a>
        </li>
        <li class="nav-item ml-auto">
          <screenTime
            :isToday="'0'"
            @changePage="changePage"
            v-if="type == 2"
            style="margin-top: 12.5px;"
          ></screenTime>
        </li>
        <div class="block-header block-header-default" style="padding-left: 0;">
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </ul>
      <div class="block-content tab-content overflow-hidden">
        <div class="tab-pane fade show active" id="btabs-animated-fade-1" role="tabpanel">
          <deviceWarnList ref="deviceWarnList"></deviceWarnList>
        </div>
        <div class="tab-pane fade" id="btabs-animated-fade-2" role="tabpanel">
          <historyWarnList ref="historyWarnList"></historyWarnList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import screenTime from "../../../components/screenTime";
import pageSize from "../../../components/pageSize";
import deviceWarnList from "./carportAlarmInfo";
import historyWarnList from "./carportAlarmHistoryInfo";

export default {
  name: "index",
  data() {
    return {
      userPackages: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      state: "",
      clipboard: null,
      sorting: "",
      orderBy: false,
      type: 1,
      bis: [
        {
          BIS_NAME: "实时告警",
          BIS_TYPE: 1
        },
        {
          BIS_NAME: "历史告警",
          BIS_TYPE: 2
        }
      ]
    };
  },
  components: {
    screenTime,
    pageSize,
    deviceWarnList,
    historyWarnList
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {},
  mounted() {
    this.getList();
  },
  methods: {
    changePage(val) {
      this.page = val;
    },
    showTab(el, type) {
      this.type = type;
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane`)) {
        i.className = "tab-pane fade";
      }
      $(`#${el}`).tab("show");
      if (type == 1) {
        this.$refs.deviceWarnList.getList();
      } else {
        this.$refs.historyWarnList.getList();
      }
    },
    getList() {
      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByRealAlert/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`
        )
        .then(res => {
          if (res.data.code === 200) {
            let list = res.data.data.data;
            if (list.length) {
              this.changeRecordNum(list[0]);
            }
          }
        });
    },
    changeRecordNum(val) {
      this.$http
        .post(`${Util.operateURL}/user/updateAlertUserRecord`, {
          alertType: "carport",
          pileNo: val.DEVICE_SN
        })
        .then(
          res => {},
          err => {
            console.log(err);
          }
        );
    }
  }
};
</script>